import { render, staticRenderFns } from "./natural-carousel.vue?vue&type=template&id=04914457&scoped=true"
import script from "./natural-carousel.vue?vue&type=script&lang=js"
export * from "./natural-carousel.vue?vue&type=script&lang=js"
import style0 from "./natural-carousel.vue?vue&type=style&index=0&id=04914457&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04914457",
  null
  
)

export default component.exports